export default __webpack_public_path__ + "static/media/english-to-hindi-screenshot-04.abf256e8.png";